export function normalizeHotelSiteUrl(web) {
    if (web == null) {
        return null;
    }

    let value = String(web).trim();
    if (value === '') {
        return null;
    }

    value = value.replace(/\/+$/, '');

    if (!/^https?:\/\//i.test(value)) {
        value = `https://${value}`;
    }

    try {
        const parsed = new URL(value);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return null;
        }
        if (!parsed.hostname || parsed.hostname.indexOf('.') === -1) {
            return null;
        }
        return `https://${parsed.host}`;
    } catch (e) {
        return null;
    }
}

export function purgeOffertaCache(siteBaseUrl, idOfferta) {
    const base = String(siteBaseUrl).replace(/\/+$/, '');
    const url = `${base}/wp-json/adriasonline/v1/offerte/${idOfferta}/purge-cache`;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 4000);

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log(
    //     '%c[WAO purge] POST sito hotel',
    //     'color:#06c;font-weight:bold',
    //     url
    // );

    return fetch(url, {
        method: 'POST',
        referrerPolicy: 'origin',
        signal: controller.signal
    }).then(
        response => {
            clearTimeout(timeoutId);
            // Logs per purge cache offerte sito hotel (disattivati)
            // console.log(
            //     '%c[WAO purge] risposta sito hotel',
            //     response.ok
            //         ? 'color:#0a7;font-weight:bold'
            //         : 'color:#c00;font-weight:bold',
            //     { status: response.status, ok: response.ok, url }
            // );
            if (!response.ok) {
                throw new Error('purge-cache failed');
            }
            return response;
        },
        error => {
            clearTimeout(timeoutId);
            // Logs per purge cache offerte sito hotel (disattivati)
            // console.error('[WAO purge] errore sito hotel', { url, error });
            throw error;
        }
    );
}
